import React from 'react';
import _ from 'lodash';
import Debug from 'debug';
import shallowCompare from '../../../lib/shallowCompare';
import styles from './index.sass';
const debug = Debug('delectable');

class SuggestItem extends React.Component {
  static defaultProps = {
    isActive: false,
    suggest: {
      label: ''
    },
    onSuggestSelect: () => {}
  };

  handleOnClick(e) {
    e.preventDefault();
    this.props.onSuggestSelect(this.props.suggest);
  }

  getSuggestClasses() {
    const className = this.props.suggest.className;
    let classes = styles.suggestItem;
    classes += this.props.isActive ? (' ' + styles.suggestItemActive) : '';
    classes += className ? (' ' + className) : '';
    return classes;
  }

  render() {
    let matches = this.props.suggest.label.split(/,(.+)/);
    let title = matches[0];
    let subtitle = matches[1] ? _.trim(matches[1].replace(', United States', '')) : '';
    return (
      <li className={this.getSuggestClasses()} onClick={this.handleOnClick.bind(this)}>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subtitle}</span>
      </li>
    );
  }
}

export default SuggestItem;



// WEBPACK FOOTER //
// banquet/components/AddressSearch/SuggestItem/index.js